import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import AxisButton from '../../components/button/button';
import Text from '../../components/typography/typgraphy';
import "./notAllowedCharsModal.scss";
import { notAllowedChars } from './notAllowedCharsHtml';

const NotAllowedCharsModal=({ setOpenModal, openModal }) => {

    // const handleBack = () => {
    //     setOpenModal(false)
    // }

    return(
        <Modal
            open={openModal}
            onClose={()=>setOpenModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className='restricted-chars-modal-box'
        >
            <Box className='restricted-chars-modal-dialog-box'>
                {/* <div className='restricted-chars-modal-dialog-box__head'>Safe Usage Guidelines</div> */}
                <div className='restricted-chars-modal-dialog-box__content'>
                    <div className="restricted-chars-modal-dialog-box__content__text" dangerouslySetInnerHTML={{ __html: notAllowedChars }} />
                </div>
                {/* <div className='restricted-chars-modal-dialog-box__action-btn'>
                    <AxisButton onClick={handleBack} className='sug-modal-back-button' customStyle={"submit-btn-primary"} variant="contained">
                        <Text className={"submit-btn-text"}>Close</Text>
                    </AxisButton>
                </div> */}
            </Box>
        </Modal>
    );
}

export default NotAllowedCharsModal;